// extracted by mini-css-extract-plugin
export var container = "styles-module--container--ee209";
export var leftSide = "styles-module--left-side--ddf08";
export var separator = "styles-module--separator--5b0a3";
export var titleBlock = "styles-module--title-block--8bd73";